import React from 'react';
import { userManagementRoute } from '@/modules/administration/user-management/routes';
import { createRoute } from '@tanstack/react-router';
import z from 'zod';

const USER_SORT_VALUES = ['date_joined', 'email', 'id'] as const;
export const USER_ORDER_VALUES = ['desc', 'asc'] as const;

export const isUserSortSearchParamValue = (
  value: string
): value is (typeof USER_SORT_VALUES)[number] => {
  return USER_SORT_VALUES.includes(value as (typeof USER_SORT_VALUES)[number]);
};

const userSearchParamsSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  size: z.coerce.number().min(1).default(50),
  sort: z.enum(USER_SORT_VALUES).default('date_joined'),
  order: z.enum(USER_ORDER_VALUES).default('desc'),
  email: z.string().optional(),
  groups: z.array(z.coerce.number()).optional(),
  user: z.coerce.number().optional(),
  rfid: z.string().optional(),
  cols: z.array(z.coerce.string()).optional(),
});

export const usersRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: 'users',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/Users/users/user-list')),
  validateSearch: (search) => {
    const result = userSearchParamsSchema.safeParse(search);
    if (!result.success) throw result.error;
    return result.data;
  },
});
